// On mobile (≤989px): move price + buy button into the fixed sticky bar.
// On desktop (≥990px): restore them to their original position.
// Resize is handled via matchMedia listener — no page refresh needed.
// Show/hide within mobile is handled purely by CSS :has().
document.addEventListener('DOMContentLoaded', function () {
  const infoContainer = document.querySelector('.product__info-container[data-source]');
  if (!infoContainer) return;

  const sectionId        = infoContainer.dataset.source;
  const stickyBar        = document.getElementById('product-sticky-bar-' + sectionId);
  const priceWrapper     = document.getElementById('price-' + sectionId);
  const productForm      = document.querySelector('product-form[data-source="' + sectionId + '"]');

  if (!stickyBar || !priceWrapper || !productForm) return;

  const maybeInstallment = priceWrapper.nextElementSibling;
  const installmentWrapper = (maybeInstallment && maybeInstallment.classList.contains('installment-wrapper'))
    ? maybeInstallment : null;
  const buyButtonsWrapper = productForm.parentElement;
  const inventoryDelivery = infoContainer.querySelector('.inventory-delivery');

  // Insert hidden anchors to remember original DOM positions before moving anything
  const makeAnchor = function (el) {
    var a = document.createElement('div');
    a.hidden = true;
    el.parentNode.insertBefore(a, el);
    return a;
  };
  var priceAnchor       = makeAnchor(priceWrapper);
  var installmentAnchor = installmentWrapper ? makeAnchor(installmentWrapper) : null;
  var buyAnchor         = makeAnchor(buyButtonsWrapper);
  var uspAnchor         = inventoryDelivery ? makeAnchor(inventoryDelivery) : null;

  function moveToBar() {
    stickyBar.appendChild(buyButtonsWrapper);
    stickyBar.appendChild(priceWrapper);
    if (installmentWrapper) stickyBar.appendChild(installmentWrapper);
    if (inventoryDelivery) stickyBar.appendChild(inventoryDelivery);
  }

  function moveToPage() {
    priceAnchor.parentNode.insertBefore(priceWrapper, priceAnchor.nextSibling);
    if (installmentWrapper) installmentAnchor.parentNode.insertBefore(installmentWrapper, installmentAnchor.nextSibling);
    buyAnchor.parentNode.insertBefore(buyButtonsWrapper, buyAnchor.nextSibling);
    if (inventoryDelivery) uspAnchor.parentNode.insertBefore(inventoryDelivery, uspAnchor.nextSibling);
  }

  var mq = window.matchMedia('(max-width: 989px)');
  mq.addEventListener('change', function (e) {
    e.matches ? moveToBar() : moveToPage();
  });
  if (mq.matches) moveToBar();

  const footer = document.querySelector('footer');
  if (footer && stickyBar) {
    const footerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('product-sticky-bar--hidden', entry.isIntersecting);
      });
    });
    footerObserver.observe(footer);
  }

  // iOS Chrome/Safari: position:fixed bottom:0 is anchored to the *layout*
  // viewport, which stays fixed while the visual viewport shrinks/grows as the
  // address bar collapses. This causes the bar to visually drift upward.
  // The Visual Viewport API lets us correct the bottom offset in real time.
  if (window.visualViewport) {
    function syncBarToViewport() {
      if (!mq.matches) {
        stickyBar.style.bottom = '';
        return;
      }
      var vv = window.visualViewport;
      // Distance between the bottom of the layout viewport and the bottom of
      // the visual viewport (positive when the URL bar / keyboard is visible).
      var bottomGap = window.innerHeight - (vv.offsetTop + vv.height);
      stickyBar.style.bottom = Math.max(0, bottomGap) + 'px';
    }
    window.visualViewport.addEventListener('resize', syncBarToViewport);
    window.visualViewport.addEventListener('scroll', syncBarToViewport);
    syncBarToViewport();
  }
});